/**
 * The next interfaces for custom errors defined on API or Backend level
 * That custom errors generally came as a response in services with 200 code
 * So, they are not considered formal errors, just informative messages that can
 * treated as errors.
 *
 * Check next service as an example on how to handle that "errors" with the `logCustomError` method
 * /libs/digital-customer-loyalty/skymiles/overview/smart/src/lib/data-access/services/status-tracker-data.service.ts
 */
export interface CustomErrorBase {
  code: string;
  message: string;
  developerMessage: string;
}

export type GenericError = Pick<CustomErrorBase, 'code' | 'message'>;

export interface CustomErrorDetails extends CustomErrorBase {
  moreInfo: Pick<CustomErrorBase, 'code' | 'message'>[];
}

export interface CustomError {
  errorResponse: CustomErrorDetails;
}

export interface CustomErrorVariantDetails {
  errorCode: string;
  errorMessage: string;
}

export interface CustomErrorVariant {
  format: string;
  error: CustomErrorVariantDetails;
}
